var _g, _path, _path2, _g2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 289,
    viewBox: "0 0 289 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_5789_2661_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0258534 -0.0258534 0 86.078 211.524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1027.98,
    height: 1027.98,
    fill: "url(#paint0_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1027.98,
    height: 1027.98,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1027.98,
    height: 1027.98,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1027.98,
    height: 1027.98,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.931 211.524C93.8019 215.789 90.3427 219.248 86.078 237.378C81.8134 219.248 78.3571 215.789 60.2246 211.524C78.3571 207.26 81.8134 203.803 86.078 185.671C90.3427 203.803 93.8019 207.26 111.931 211.524Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"stopsVar\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"transform\":{\"m00\":3.1661322885966113e-15,\"m01\":-51.706863403320312,\"m02\":111.93147277832031,\"m10\":51.706863403320312,\"m11\":3.1661322885966113e-15,\"m12\":185.67089843750},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5789_2661",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 289,
    height: 289
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H289V289H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5789_2661)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_5789_2661_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.144484 -0.144484 0 144.484 144.484)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1005.01,
    height: 1005.01,
    fill: "url(#paint1_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1005.01,
    height: 1005.01,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1005.01,
    height: 1005.01,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1005.01,
    height: 1005.01,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.969 144.483C155.358 150.491 150.491 155.358 144.483 288.969C138.477 155.358 133.611 150.491 0 144.483C133.611 138.477 138.477 133.608 144.483 0C150.491 133.608 155.361 138.477 288.969 144.483Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"stopsVar\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"transform\":{\"m00\":1.7694240441335635e-14,\"m01\":-288.96887207031250,\"m02\":288.96887207031250,\"m10\":288.96887207031250,\"m11\":1.7694240441335635e-14,\"m12\":-1.7694240441335635e-14},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_5789_2661_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0322673 -0.0322673 0 79.6013 68.1736)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1022.42,
    height: 1022.42,
    fill: "url(#paint2_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1022.42,
    height: 1022.42,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1022.42,
    height: 1022.42,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1022.42,
    height: 1022.42,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.869 68.1722C82.0304 69.5146 80.9423 70.6026 79.6027 100.441C78.2603 70.6026 77.1723 69.5146 47.334 68.1722C77.1723 66.8326 78.2603 65.7445 79.6027 35.9062C80.9423 65.7445 82.0304 66.8326 111.869 68.1722Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"stopsVar\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"transform\":{\"m00\":3.9516090222333367e-15,\"m01\":-64.534667968750,\"m02\":111.868652343750,\"m10\":64.534667968750,\"m11\":3.9516090222333367e-15,\"m12\":35.906250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_diamond_5789_2661_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0473843 -0.0473843 0 226.5 65.4409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1015.27,
    height: 1015.27,
    fill: "url(#paint3_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1015.27,
    height: 1015.27,
    transform: "scale(1 -1)",
    fill: "url(#paint3_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1015.27,
    height: 1015.27,
    transform: "scale(-1 1)",
    fill: "url(#paint3_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1015.27,
    height: 1015.27,
    transform: "scale(-1)",
    fill: "url(#paint3_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.884 65.4424C230.068 67.4122 228.471 69.0089 226.501 112.825C224.531 69.0089 222.934 67.4122 179.115 65.4424C222.934 63.4725 224.531 61.8758 226.501 18.0566C228.471 61.8758 230.068 63.4725 273.884 65.4424Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"stopsVar\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"transform\":{\"m00\":5.8029032899936488e-15,\"m01\":-94.768600463867188,\"m02\":273.88385009765625,\"m10\":94.768600463867188,\"m11\":5.8029032899936488e-15,\"m12\":18.0566406250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_diamond_5789_2661_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0129069 -0.0129069 0 260.967 33.1696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    fill: "url(#paint4_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    transform: "scale(1 -1)",
    fill: "url(#paint4_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    transform: "scale(-1 1)",
    fill: "url(#paint4_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    transform: "scale(-1)",
    fill: "url(#paint4_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.874 33.1696C261.94 33.7066 261.504 34.1418 260.967 46.0766C260.433 34.1418 259.998 33.7066 248.061 33.1696C259.998 32.6355 260.433 32.2003 260.967 20.2627C261.504 32.2003 261.94 32.6355 273.874 33.1696Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"stopsVar\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"transform\":{\"m00\":1.5806436300691584e-15,\"m01\":-25.813867568969727,\"m02\":273.87442016601562,\"m10\":25.813867568969727,\"m11\":1.5806436300691584e-15,\"m12\":20.26269531250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint5_diamond_5789_2661_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0129069 -0.0129069 0 186.528 18.0563)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    fill: "url(#paint5_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    transform: "scale(1 -1)",
    fill: "url(#paint5_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    transform: "scale(-1 1)",
    fill: "url(#paint5_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1056.05,
    height: 1056.05,
    transform: "scale(-1)",
    fill: "url(#paint5_diamond_5789_2661)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.435 18.0563C187.5 18.5905 187.065 19.0257 186.528 30.9633C185.994 19.0257 185.559 18.5905 173.621 18.0563C185.559 17.5194 185.994 17.0842 186.528 5.14941C187.065 17.0842 187.5 17.5194 199.435 18.0563Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"stopsVar\":[{\"color\":{\"r\":0.48941177129745483,\"g\":0.60000002384185791,\"b\":0.58352941274642944,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.81568628549575806,\"g\":1.0,\"b\":0.97254902124404907,\"a\":1.0},\"position\":0.41826921701431274}],\"transform\":{\"m00\":1.5806436300691584e-15,\"m01\":-25.813867568969727,\"m02\":199.43496704101562,\"m10\":25.813867568969727,\"m11\":1.5806436300691584e-15,\"m12\":5.14941406250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_5789_2661_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.931 211.524C93.8019 215.789 90.3427 219.248 86.078 237.378C81.8134 219.248 78.3571 215.789 60.2246 211.524C78.3571 207.26 81.8134 203.803 86.078 185.671C90.3427 203.803 93.8019 207.26 111.931 211.524Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_5789_2661_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.969 144.483C155.358 150.491 150.491 155.358 144.483 288.969C138.477 155.358 133.611 150.491 0 144.483C133.611 138.477 138.477 133.608 144.483 0C150.491 133.608 155.361 138.477 288.969 144.483Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_5789_2661_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.869 68.1722C82.0304 69.5146 80.9423 70.6026 79.6027 100.441C78.2603 70.6026 77.1723 69.5146 47.334 68.1722C77.1723 66.8326 78.2603 65.7445 79.6027 35.9062C80.9423 65.7445 82.0304 66.8326 111.869 68.1722Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_diamond_5789_2661_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.884 65.4424C230.068 67.4122 228.471 69.0089 226.501 112.825C224.531 69.0089 222.934 67.4122 179.115 65.4424C222.934 63.4725 224.531 61.8758 226.501 18.0566C228.471 61.8758 230.068 63.4725 273.884 65.4424Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_diamond_5789_2661_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.874 33.1696C261.94 33.7066 261.504 34.1418 260.967 46.0766C260.433 34.1418 259.998 33.7066 248.061 33.1696C259.998 32.6355 260.433 32.2003 260.967 20.2627C261.504 32.2003 261.94 32.6355 273.874 33.1696Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint5_diamond_5789_2661_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.435 18.0563C187.5 18.5905 187.065 19.0257 186.528 30.9633C185.994 19.0257 185.559 18.5905 173.621 18.0563C185.559 17.5194 185.994 17.0842 186.528 5.14941C187.065 17.0842 187.5 17.5194 199.435 18.0563Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_5789_2661",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418269,
    stopColor: "#D0FFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_5789_2661",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418269,
    stopColor: "#D0FFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_5789_2661",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418269,
    stopColor: "#D0FFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_diamond_5789_2661",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418269,
    stopColor: "#D0FFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_diamond_5789_2661",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418269,
    stopColor: "#D0FFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_diamond_5789_2661",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D9995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418269,
    stopColor: "#D0FFF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.2ebdd1cd942d283aef5a13d54128fd6b.svg";
export { ForwardRef as ReactComponent };